import axios from 'axios';
import Cookies from 'js-cookie';
import ORCH_BASE_URL from '../config/orchConfig';


const orchestratorAxios = axios.create({
  baseURL: ORCH_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

orchestratorAxios.interceptors.request.use(
  (config) => {
    const token = Cookies.get('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default orchestratorAxios;
